import React, { useEffect, useState } from "react";
import { CTA_URL, LANDING_COPY } from "../constants";

const StickyMobileCta: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hero = document.getElementById("inicio");
    if (!hero) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting),
      { threshold: 0, rootMargin: "-80px 0px 0px 0px" },
    );

    observer.observe(hero);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-40 border-t border-zinc-300 bg-white/95 p-3 backdrop-blur-md transition-all md:hidden ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <a
        href={CTA_URL}
        className="block rounded-lg bg-brand-pink py-3 text-center text-xs font-semibold uppercase tracking-[0.1em] text-white"
      >
        {LANDING_COPY.hero.primaryCta}
      </a>
    </div>
  );
};

export default StickyMobileCta;
